import { Entry } from '../Entry'

export function Entry20231115() {
  return (
    <Entry title="Nov 15 2023 - v3.5.5">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15550/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
